import { Application } from "@hotwired/stimulus";
import AutosaveController from "./autosave_controller";
import TextareaAutogrow from "stimulus-textarea-autogrow";
import CountdownController from "./countdown_controller";
import SaveStatusController from "./save_status_controller";

const application = Application.start();
application.debug = false;
window.Stimulus = application;

application.register("autosave", AutosaveController);
application.register("countdown", CountdownController);
application.register("save-status", SaveStatusController);
application.register("textarea-autogrow", TextareaAutogrow);

export { application };
